var _rect, _rect2, _rect3, _rect4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCard5(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 45,
    height: 45,
    viewBox: "0 0 45 45",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 18.6792,
    height: 24.2308,
    fill: "#256BE4"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    y: 31.1538,
    width: 18.6792,
    height: 13.8462,
    fill: "#F7F7F7"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 45,
    y: 45,
    width: 18.6792,
    height: 24.2308,
    transform: "rotate(-180 45 45)",
    fill: "#256BE4"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 45,
    y: 13.8462,
    width: 18.6792,
    height: 13.8462,
    transform: "rotate(-180 45 13.8462)",
    fill: "#F7F7F7"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCard5);
export default __webpack_public_path__ + "static/media/card5.fe21e51c6cc760d8716ddbaf227c0f1f.svg";
export { ForwardRef as ReactComponent };